import { CALL_API } from 'middlewares/api';
import { url } from 'configs';
const {
  NEWTUBE_API_SERVER,
} = url;

const FETCH_PERMISSIONLIST_REQUEST = 'shared/companyspace/permission/FETCH_PERMISSIONLIST_REQUEST';
const FETCH_PERMISSIONLIST_SUCCESS = 'shared/companyspace/permission/FETCH_PERMISSIONLIST_SUCCESS';
const FETCH_PERMISSIONLIST_ERROR = 'shared/companyspace/permission/FETCH_PERMISSIONLIST_ERROR';

const FETCH_PERMISSIONITEM_REQUEST = 'shared/companyspace/permission/FETCH_PERMISSIONITEM_REQUEST';
const FETCH_PERMISSIONITEM_SUCCESS = 'shared/companyspace/permission/FETCH_PERMISSIONITEM_SUCCESS';
const FETCH_PERMISSIONITEM_ERROR = 'shared/companyspace/permission/FETCH_PERMISSIONITEM_ERROR';

const PUT_PERMISSIONITEM_REQUEST = 'shared/companyspace/permission/PUT_PERMISSIONITEM_REQUEST';
const PUT_PERMISSIONITEM_SUCCESS = 'shared/companyspace/permission/PUT_PERMISSIONITEM_SUCCESS';
const PUT_PERMISSIONITEM_ERROR = 'shared/companyspace/permission/PUT_PERMISSIONITEM_ERROR';

export default function reducer(state = {
  permissionListDatas: [],
  permissionItemEmployeeArray: [],
  isLoadingList: false,
}, action) {
  switch (action.type) {
    case FETCH_PERMISSIONLIST_REQUEST:
      return Object.assign({}, state, {
        isLoadingList: true,
      });
    case FETCH_PERMISSIONLIST_SUCCESS:
      return Object.assign({}, state, {
        isLoadingList: false,
        permissionListDatas: action.response.data,
      });
    case FETCH_PERMISSIONLIST_ERROR:
      return Object.assign({}, state, {
        isLoadingList: false,
      });
    case FETCH_PERMISSIONITEM_REQUEST:
      return Object.assign({}, state, {
        isLoadingItem: true,
      });
    case FETCH_PERMISSIONITEM_SUCCESS:
      return Object.assign({}, state, {
        isLoadingItem: false,
        permissionItemEmployeeArray: action.response.data.employees,
      });
    case FETCH_PERMISSIONITEM_ERROR:
      return Object.assign({}, state, {
        isLoadingItem: false,
      });
    default:
      return state;
  }
  return action.type;
}

export function fetchPermissionList() {
  return {
    [CALL_API]: {
      url: `${NEWTUBE_API_SERVER}HRMMiddleware/ModuleRole`,
      method: 'GET',
      types: [
        FETCH_PERMISSIONLIST_REQUEST,
        FETCH_PERMISSIONLIST_SUCCESS,
        FETCH_PERMISSIONLIST_ERROR,
      ],
    },
  };
}

export function fetchPermissionItem(moduleCode) {
  return {
    [CALL_API]: {
      url: `${NEWTUBE_API_SERVER}HRMMiddleware/ModuleRole/${moduleCode}`,
      method: 'GET',
      types: [
        FETCH_PERMISSIONITEM_REQUEST,
        FETCH_PERMISSIONITEM_SUCCESS,
        FETCH_PERMISSIONITEM_ERROR,
      ],
    },
  };
}

export function putPermissionItem(moduleCode, paramsData) {
  return {
    [CALL_API]: {
      url: `${NEWTUBE_API_SERVER}HRMMiddleware/ModuleRole/${moduleCode}`,
      method: 'POST',
      types: [
        PUT_PERMISSIONITEM_REQUEST,
        PUT_PERMISSIONITEM_SUCCESS,
        PUT_PERMISSIONITEM_ERROR,
      ],
      params: paramsData,
    },
  };
}



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/417/s/Tube.Frontend/src/containers/App/screens/Tube/screens/CompanySpace/screens/Permission/reducers/index.js
 **/